<div class="marker-popup-content">
  <span class="popup-tittle">{{item.provider}} {{item.building ? "- " + item.building : ''}}</span>
  <div class="copy-id-container">
    <i class="pi pi-code copy-id-icon" 
       [title]="showCopiedTooltip ? 'Copied datacenter id' : 'ID: ' + item.id + ' (Click to copy)'"
       (click)="copyIdToClipboard(item.id)"></i>
    <div class="copied-tooltip" *ngIf="showCopiedTooltip">
      Copied datacenter Id
    </div>
  </div>
  <div class="modification-info" *ngIf="item?.updatedAt || item?.createdAt">
      <span>
        {{ item?.updatedAt ? 'Updated' : (item?.createdAt ? 'Created' : '') }}
        {{ (item?.updatedAt || item?.createdAt) | date:'d MMMM yyyy HH:mm' }}
      </span>
  </div>
  <hr>
  <span><b>MW Live</b> - {{item.mwLive | number:'1.0':'en-US'}}</span><br/>
  <span><b>MW U/C</b> - {{item.mwUC | number:'1.0':'en-US'}}</span><br/>
  <span><b>MW Planned</b> - {{item.mwPlanned | number:'1.0':'en-US'}}</span><br/>
  <span><b>Data Hall Live</b> - {{item.dataHallLive | number:'1.0':'en-US'}}</span><br/>
  <span><b>Market Area</b> - {{item.area}}</span><br/>
  <span><b>Building Area</b> - {{item.buildingAreaTotal ? (item.buildingAreaTotal | number:'1.0':'en-US') : ""}}</span><br/>
  <span><b>Building Tenant</b> - {{item.buildingTenant?.join(', ')}}</span><br/>
  <span><b>Year Live</b> - {{item.firstYearOp}}</span><br/>
  <span><b>Site Type</b> - {{item.siteType?.join(', ')}}</span><br/>
  <span><b>Product Type</b> - {{item.productType?.join(', ')}}</span><br/>
  <span><b>Sellable IT Load</b> - {{item.sellableITLoad | number:'1.0':'en-US'}}</span><br/>
  <span><b>Campus</b> - {{item.campus}}</span><br/>
  <span><b>Address</b> - {{item.address}}</span><br/>
  <span><b>Data Source</b> - {{item.dataSource?.join(', ')}}</span><br/>
  <span><b>Weighted Average Lease Term</b> - {{item.weightedAverageLeaseTermYears | number:'1.0':'en-US'}}</span><br/>
  <span><b>Parcel Size (Acres)</b> - {{item.parcelSizeAcres | number:'1.0':'en-US'}}</span><br/>
  <span><b>Lat/Long</b> - {{item.lat | number:'1.0-6'}}, {{item.lon | number:'1.0-6'}}</span><br/><br/>
  <p-button styleClass="p-button-primary primary p-button-sm" icon="pi pi-file-edit"
            (onClick)="modifyDatacenter(item)"></p-button>
  <p-button styleClass="p-button-primary secondary p-button-sm red" icon="pi pi-trash"
            (onClick)="removeDatacenter(item)"></p-button>
  <p-button styleClass="p-button-primary secondary p-button-sm" icon="pi pi-copy"
            (onClick)="copyMarkerInfo(item)"></p-button>
  <p-button *ngIf="hasAvailabilityZone(item)"
            styleClass="p-button-primary secondary p-button-sm" 
            [icon]="getAzVisibility() ? 'pi pi-eye' : 'pi pi-eye-slash'"
            [label]="getAzVisibility() ? 'Hide AZ' : 'Show AZ'"
            (onClick)="toggleAvailabilityZoneVisibility(item)"></p-button>
</div>
